import Agendas from "containers/agendas/agendas";
import MultipleAnalyseModal from "containers/analyse-modal/multiple-analyse-modal/multiple-analyse-modal";
import AnalyseShapeModal from "containers/analyse-modal/analyse-shape-modal/analyse-shape-modal";
import SingleAnalyseModal from "containers/analyse-modal/single-analyse-modal/single-analyse-modal";
import Layers from "containers/layers/layers";
import LocationSetDetail from "containers/location-set-detail/location-set-detail";
import LocationSets from "containers/location-sets/location-sets";
import Map from "containers/map/amap";
import MultiLocations from "containers/multi-locations/multi-locations";
import SingleLocation from "containers/single-location/single-location";
import EventsLocation from "containers/events-location/events-location";
import LineAnalysed from "containers/line-analysed/line-analysed";
import PolygonAnalysed from "containers/polygon-analysed/polygon-analysed";
import { LeftPanel, RightPanel } from "helpers/constants";
import { AppContext, AppAction } from "helpers/context";
import { MapSize, AgendasSize } from "helpers/models";
import { useContext, useEffect } from "react";
import {
  getLayer,
  getCrsLayer,
  getFutureHazardLayer,
  getCrsComponentLayer,
  getLocationsets,
  getEventList,
  getUserNotifications
} from "api/layer";
import { getShapeList, ShapeListItem } from "api/my-shape";
import styles from "./home.module.scss";
import ImportModal from "containers//multi-import-modal/import-modal/import-modal";
import ImportMenu from "containers//multi-import-modal/import-menu/import-menu";
import CreateModal from "containers//multi-import-modal/create-modal/create-modal";
import ErrorModal from "containers//multi-import-modal/error-modal/error-modal";
import AddLocation from "containers/location-set-detail/add/add-location";
import EditLocationSet from "containers/location-sets/edit/edit-location-set";
import EditModal from "containers/multi-import-modal/edit-modal/edit-modal";
import LocationAnalysisDetails from "components/results/location-analysis-details/location-analysis-details";
import DeleteLocationSetModal from "containers/location-sets/delete/delete-location-set";
import DeleteLocationModal from "containers/location-set-detail/delete/delete-location";
import AddressEncoding from "containers/multi-import-modal/address-encoding/address-encoding";
import HiddenLocationsModal from "containers/location-set-detail/hiddenLocations/hidden-locations";
import System from "containers/system/system";
import Events from "containers/events/events";
import MultipleFathomPopup from "containers/analyse-modal/fathom-popup/multiple-fathom-popup";
import ShapeFathomPopup from "containers/analyse-modal/fathom-popup/shape-fathom-popup";
import SingleFathomPopup from "containers/analyse-modal/fathom-popup/single-fathom-popup";
import ShapeInfo from "containers/shape-info/shape-info";

import {
  Dialog,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from "@mui/material";
import { ReactComponent as PremiumAddSvg } from "assets/premium+.svg";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import MyShapes from "containers/my-shapes/my-shapes";

function Home() {
  const [context, dispatch] = useContext(AppContext);
  const locationsSize = context.locationsSize;
  const locationSetEdit = context.multipleLocationsEdit;
  const [t] = useTranslation();

  const mapProjectTypeToShapeType = (value?: string) => {
    if (value === "ABOVE") return "Aboveground";
    if (value === "UNDER") return "Underground";
    return "Ground";
  };

  const mapGeometryTypeToCategory = (value?: string) => {
    return value === "POLYGON" ? "polygon" : "polyline";
  };

  const normalizeShapeFromApi = (item: ShapeListItem) => {
    const id = (item.id || item.shapeId || item.shape_id || "") as string;
    const shapeName = (item.shapeName ||
      item.shape_name ||
      item.name ||
      "") as string;
    const geometryInfo = (item.geometryInfo ||
      item.geometry_info ||
      item.feature ||
      "") as string;
    if (!id || !shapeName || !geometryInfo) {
      return undefined;
    }

    const category = mapGeometryTypeToCategory(
      (item.geometryType || item.geometry_type) as string
    );

    return {
      id,
      name: shapeName,
      category,
      type:
        category === "polygon"
          ? "Region"
          : mapProjectTypeToShapeType(item.projectType || item.project_type),
      sourceType: (item.sourceType || item.source_type || "INPUT") as
        | "INPUT"
        | "IMPORT",
      spatial: (item.spatial === "GCJ02" ? "GCJ02" : "WGS84") as
        | "GCJ02"
        | "WGS84",
      createTime: item.createTime,
      feature: geometryInfo
    };
  };

  const groupByCategory = (arr: any) => {
    let newArr: any[] = [];
    const arrF = arr.filter(
      (e: any) => e.id !== "GEO_DistToCoast_Global_SwissRe"
    );
    const arrG = arrF.map((e: any) => {
      if (
        e.id === "DR_Subsidence_France_SwissRe" ||
        e.id === "WF_DistToBush_AUS_SwissRe"
      ) {
        return {
          ...e,
          group: "Additional Local Maps"
        };
      }
      return e;
    });
    arrG.forEach((item: any, i: number) => {
      let index = -1;
      let isExists = newArr.some((newItem, j) => {
        // 这里是判断字段，根据(时间日期) month
        if (item.group === newItem.name) {
          index = j;
          return true;
        }
        return false;
      });
      if (!isExists) {
        newArr.push({
          name: item.group,
          children: [{ ...item, checked: false, opacity: 0.5 }]
        });
      } else {
        newArr[index].children.push({ ...item, checked: false, opacity: 0.5 });
      }
    });
    return newArr;
  };

  const getLayerList = () => {
    getLayer().then((res: any) => {
      const layerList = groupByCategory(res.data);
      dispatch({
        type: AppAction.setLayerData,
        payload: res.data.filter(
          (e: any) => e.id !== "GEO_DistToCoast_Global_SwissRe"
        )
      });
      dispatch({ type: AppAction.setLayerList, payload: layerList });
    });
  };

  const getCrsRiskTypeList = () => {
    getCrsLayer().then((res: any) => {
      dispatch({ type: AppAction.setCrsLayerList, payload: res.data });
    });
  };

  const getFutureHazardRiskTypeList = () => {
    getFutureHazardLayer().then((res: any) => {
      dispatch({ type: AppAction.setFutureHazardLayerList, payload: res.data });
    });
  };

  const getCrsComponentRiskTypeList = () => {
    getCrsComponentLayer().then((res: any) => {
      dispatch({ type: AppAction.setCrsComponentLayerList, payload: res.data });
    });
  };

  const getMultipleLocationsList = async () => {
    dispatch({ type: AppAction.setMultipleLocationsLoadings, payload: true });
    const res = await getLocationsets();
    dispatch({ type: AppAction.setLocationSets, payload: res.data });
    dispatch({ type: AppAction.setMultipleLocationsLoadings, payload: false });
  };

  const getEventDataList = async () => {
    dispatch({ type: AppAction.setEventsListStatus, payload: "1" });
    try {
      const res: any = await getEventList({
        fromDateTime: context.eventsFilterForm.fromDateTime,
        toDateTime: context.eventsFilterForm.toDateTime,
        longitude: context.eventsFilterForm.longitude,
        latitude: context.eventsFilterForm.latitude,
        country: context.eventsFilterForm.country,
        oversea: context.eventsFilterForm.oversea,
        spatial: context.eventsFilterForm.spatial
      });

      if (res.code !== 200)
        dispatch({ type: AppAction.setEventsListStatus, payload: "3" });

      let data: any = [],
        isReset = true;

      res.data.events.forEach((item: any) => {
        let isFind = context.selectedEventsList.find((e) => e.id === item.id);
        if (isFind) {
          item.checked = true;
          item.opacity = isFind.opacity;
          item.layerObj = isFind.layerObj;
          isReset = false;
        } else {
          item.checked = false;
          item.opacity = 0.5;
        }
        data.push(item);
      });

      if (isReset && context.selectedEventsList.length > 0) {
        dispatch({
          type: AppAction.addSnackBarParams,
          payload: {
            title: "eventsFilterTitle",
            titleIcon: "info",
            titleIconColor: "#fff",
            message: "eventsFilterMessage",
            footBtn: FootButton
          }
        });
      }

      dispatch({
        type: AppAction.setEventsList,
        payload: data
      });
      dispatch({ type: AppAction.setEventsListStatus, payload: "2" });
    } catch (e) {
      console.error("Error fetching event data:", e);
      dispatch({ type: AppAction.setEventsListStatus, payload: "3" });
    }
  };

  const getUserNotificationsList = () => {
    getUserNotifications().then((res: any) => {
      dispatch({ type: AppAction.setUserNotifications, payload: res.data });
    });
  };

  const getMyShapesDataList = async () => {
    dispatch({ type: AppAction.setMyShapesListStatus, payload: "1" });

    try {
      const result = await getShapeList();
      const data = (result as any)?.data;
      const mergedList = Array.isArray(data)
        ? data
        : Array.isArray(data?.rows)
          ? data.rows
          : Array.isArray(data?.records)
            ? data.records
            : [];

      const uniqueMap = new globalThis.Map<string, any>();
      mergedList.forEach((item: ShapeListItem) => {
        const normalized = normalizeShapeFromApi(item);
        if (normalized?.id) {
          uniqueMap.set(normalized.id, normalized);
        }
      });

      dispatch({
        type: AppAction.setMyShapes,
        payload: Array.from(uniqueMap.values())
      });
      dispatch({ type: AppAction.setMyShapesListStatus, payload: "2" });
    } catch {
      dispatch({ type: AppAction.setMyShapesListStatus, payload: "3" });
      dispatch({
        type: AppAction.addSnackBarParams,
        payload: {
          titleIcon: "error",
          titleIconColor: "red",
          message: "shapeListLoadFailed"
        }
      });
    }
  };

  const FootButton = () => {
    return (
      <Button
        color="success"
        style={{ marginRight: "10px" }}
        onClick={() => {
          dispatch({
            type: AppAction.setEventsFilterForm,
            payload: {
              ...context.eventsFilterForm,
              isNotRequest: false,
              fromDateTime: dayjs(
                new Date().setMonth(new Date().getMonth() - 3)
              ).format("YYYY-MM-DD"),
              toDateTime: dayjs(new Date()).format("YYYY-MM-DD"),
              isShowAll: false,
              type: [
                "Cyclone",
                "Winterstorm",
                "Earthquake",
                "Flood",
                "Rainfall"
              ]
            }
          });
          dispatch({ type: AppAction.popSnackBarParams });
        }}
      >
        {t("buttons.resetFilter")}
      </Button>
    );
  };

  useEffect(() => {
    getLayerList();
    getCrsRiskTypeList();
    getFutureHazardRiskTypeList();
    getCrsComponentRiskTypeList();
    getMultipleLocationsList();
    getUserNotificationsList();
    getMyShapesDataList();
  }, []);

  useEffect(() => {
    if (!context.eventsFilterForm.isNotRequest) {
      getEventDataList();
    }
  }, [
    context.eventsFilterForm.fromDateTime,
    context.eventsFilterForm.toDateTime
  ]);

  useEffect(() => {
    if (context.tryAgainType === "eventsList") {
      getEventDataList();
    }
  }, [context.tryAgainType]);

  const mapSize = (): MapSize => {
    if (context.arrowLeft && context.arrowRight) {
      return MapSize.L;
    }

    if (
      (context.leftPanel === LeftPanel.Locations ||
        context.leftPanel === LeftPanel.Events) &&
      context.rightPanel !== RightPanel.Empty &&
      locationsSize
    ) {
      if (context.arrowLeft) {
        return MapSize.M;
      }
      if (context.arrowRight) {
        return MapSize.S;
      }
      return MapSize.XS;
    }

    if (
      context.leftPanel !== LeftPanel.Empty &&
      context.rightPanel !== RightPanel.Empty
    ) {
      if (context.arrowLeft || context.arrowRight) {
        return MapSize.M;
      }
      return MapSize.S;
    }

    if (
      context.leftPanel !== LeftPanel.Empty ||
      context.rightPanel !== RightPanel.Empty
    ) {
      if (context.arrowLeft || context.arrowRight) {
        return MapSize.L;
      }
      return MapSize.M;
    }

    return MapSize.L;
  };

  const agendasSize = () => {
    if (context.arrowLeft || context.leftPanel === LeftPanel.Empty) {
      return AgendasSize.S;
    } else if (
      (context.leftPanel === LeftPanel.Locations ||
        context.leftPanel === LeftPanel.Events) &&
      locationsSize
    ) {
      return AgendasSize.L;
    } else {
      return AgendasSize.M;
    }
  };

  const getDialogContent = () => {
    if (context.fathomPermissionDialog === "2") {
      return t("fathom.popup.error");
    } else if (context.fathomPermissionDialog === "3") {
      return t("fathom.popup.nonFathomError");
    } else {
      return t("userSystem.fathomDialogContent");
    }
  };

  const getLeftPanelDom = () => {
    if (context.leftPanel === LeftPanel.Layers) {
      return <Layers />;
    } else if (context.leftPanel === LeftPanel.Events) {
      return <Events />;
    } else if (context.leftPanel === LeftPanel.Locations) {
      if (locationSetEdit) {
        return <LocationSetDetail />;
      } else {
        return <LocationSets />;
      }
    } else if (
      context.leftPanel === LeftPanel.AddLocation ||
      context.leftPanel === LeftPanel.EditLocation
    ) {
      return <AddLocation />;
    } else if (context.leftPanel === LeftPanel.EditLocationSet) {
      return <EditLocationSet />;
    } else if (context.leftPanel === LeftPanel.MyShapes) {
      return <MyShapes />;
    }
    return null;
  };

  const getRightPanelDom = () => {
    if (context.rightPanel === RightPanel.Single) {
      return <SingleLocation />;
    } else if (context.rightPanel === RightPanel.Multiple) {
      return <MultiLocations />;
    } else if (context.rightPanel === RightPanel.Events) {
      return <EventsLocation />;
    } else if (context.rightPanel === RightPanel.Line) {
      return <LineAnalysed />;
    } else if (context.rightPanel === RightPanel.Polygon) {
      return <PolygonAnalysed />;
    }
    return null;
  };

  return (
    <div className={styles.home}>
      {context.leftPanel === LeftPanel.UserSystem && (
        <div
          style={{
            display: "flex",
            flex: 1,
            height: "100%",
            overflow: "hidden"
          }}
        >
          <System />
        </div>
      )}
      <div
        style={{
          display: context.leftPanel === LeftPanel.UserSystem ? "none" : "flex",
          flex: 1,
          height: "100%"
        }}
      >
        <div
          className="z-[2]"
          style={{
            display: context.arrowLeft ? "none" : "",
            backgroundColor: "white"
          }}
        >
          {getLeftPanelDom()}
        </div>
        <Agendas size={agendasSize()} />
        <ImportMenu />
        <ImportModal />
        {context.createModal && <CreateModal />}
        <EditModal />
        <ErrorModal />
        <LocationAnalysisDetails />
        <DeleteLocationSetModal />
        <DeleteLocationModal />
        <AddressEncoding />
        <div className="ml-[1px] relative">
          <ShapeInfo />

          {context.leftPanel !== LeftPanel.Empty && (
            <div
              className={styles.arrowLeftIcon}
              onClick={() => {
                dispatch({
                  type: AppAction.setArrowLeft,
                  payload: !context.arrowLeft
                });
              }}
            >
              <span className="material-icons">
                {context.arrowLeft ? "arrow_right" : "arrow_left"}
              </span>
            </div>
          )}
          <Map size={mapSize()} />
          {context.rightPanel !== RightPanel.Empty && (
            <div
              className={styles.arrowRightIcon}
              onClick={() => {
                dispatch({
                  type: AppAction.setArrowRight,
                  payload: !context.arrowRight
                });
              }}
            >
              <span className="material-icons">
                {context.arrowRight ? "arrow_left" : "arrow_right"}
              </span>
            </div>
          )}
        </div>
        <div
          className="z-[2]"
          style={{
            display: context.arrowRight ? "none" : "",
            backgroundColor: "white"
          }}
        >
          {getRightPanelDom()}
        </div>
        <MultipleAnalyseModal />
        <MultipleFathomPopup />
        <AnalyseShapeModal />
        <ShapeFathomPopup />
        <SingleAnalyseModal />
        <SingleFathomPopup />
      </div>
      <HiddenLocationsModal />

      <Dialog
        open={!!context.fathomPermissionDialog}
        onClose={() => {
          dispatch({
            type: AppAction.setFathomPermissionDialog,
            payload: false
          });
        }}
        sx={{
          "& .MuiDialog-paper": {
            width: "839px",
            maxWidth: "80vw",
            maxHeight: "85vh",
            margin: "0"
          }
        }}
      >
        <div className={styles.fathomPermissionDialog}>
          <div className={styles.dialogHeader}>
            <div className={styles.dialogIconTitle}>
              <PremiumAddSvg className="mr-1 w-[24px] h-[24px]" />
              <span>{t("userSystem.roleSelect.premium+")}</span>
            </div>
            <div className={styles.dialogTitle}>
              CatNet® {t("userSystem.roleSelect.premium+")}{" "}
              {t("userSystem.modules")}
            </div>
            <div className={styles.dialogSubtitle}>
              {t("userSystem.fathomDialogTitle")}
            </div>
          </div>
          <div
            className={styles.dialogContent}
            dangerouslySetInnerHTML={{ __html: getDialogContent() }}
          ></div>
          <div className={styles.dialogFoot}>
            <Button
              color="success"
              onClick={() => {
                dispatch({
                  type: AppAction.setFathomPermissionDialog,
                  payload: false
                });
              }}
            >
              {t(`buttons.close`)}
            </Button>
          </div>
        </div>
      </Dialog>

      <Dialog
        open={!!context.fathomIconDialog}
        onClose={() => {
          dispatch({ type: AppAction.setFathomIconDialog, payload: false });
        }}
        sx={{
          "& .MuiDialog-paper": {
            maxWidth: "80vw",
            maxHeight: "85vh",
            margin: "0",
            background: "#f0f0f0"
          }
        }}
      >
        <div className={styles.fathomIconDialog}>
          <div className={styles.dialogHeader}>{t("fathom.dialogHeader")}</div>
          <div className={styles.dialogContent}>
            <div className={styles.dialogSection}>
              <div className={styles.statusCardSection}>
                <div className={styles.statusCard}>
                  <img
                    src={require(
                      `assets/image/${
                        context.language === "en"
                          ? "basic-tier-status-card.png"
                          : "basic-tier-status-card-cn.png"
                      }`
                    )}
                    alt="Basic Status Card"
                  />
                </div>
                <div className={styles.statusCard}>
                  <img
                    src={require(
                      `assets/image/${
                        context.language === "en"
                          ? "premium-status-card.png"
                          : "premium-status-card-cn.png"
                      }`
                    )}
                    alt="Premium Status Card"
                  />
                </div>
                <div className={styles.statusCard}>
                  <img
                    src={require(
                      `assets/image/${
                        context.language === "en"
                          ? "premium-plus-status-card.png"
                          : "premium-plus-status-card-cn.png"
                      }`
                    )}
                    alt="Premium Plus Status Card"
                  />
                </div>
              </div>
              <div className={styles.featureContainer}>
                <Accordion
                  sx={{
                    boxShadow: "0 1px 6px #0000001f, 0 1px 4px #0000001f",
                    width: "100%"
                  }}
                  expanded={true}
                >
                  <AccordionSummary
                    expandIcon={<div className="material-icons"></div>}
                    sx={{
                      padding: 0,
                      margin: 0,
                      flexDirection: "row-reverse",
                      "&:hover": {
                        background: "#e0e0e0"
                      },
                      "& .MuiAccordionSummary-expandIconWrapper": {
                        margin: "0 8px 0 16px"
                      },
                      "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
                        transform: "rotate(90deg)"
                      },
                      "& .MuiTypography-root": {
                        fontFamily: "Roboto-Regular"
                      },
                      "& .MuiAccordionSummary-content.Mui-expanded": {
                        margin: " 0"
                      }
                    }}
                  >
                    <div className={styles.featureHeader}>
                      <span>{t("fathom.dialogContent.exclusiveRiskData")}</span>
                      <div className={styles.tierContainer}>
                        <div>
                          <div
                            className="material-icons"
                            style={{
                              background:
                                "linear-gradient(93deg, #007934 5.26%, #c9dd03 219.08%)",
                              backgroundClip: "text",
                              WebkitTextFillColor: "transparent"
                            }}
                          >
                            check_circle
                          </div>
                          <span>{t("fathom.dialogContent.accessToBasic")}</span>
                        </div>
                        <div>
                          <div
                            className="material-icons"
                            style={{
                              background:
                                "linear-gradient(93deg, #007934 5.26%, #c9dd03 219.08%)",
                              backgroundClip: "text",
                              WebkitTextFillColor: "transparent"
                            }}
                          >
                            check_circle
                          </div>
                          <span>
                            {t("fathom.dialogContent.variousSwissRe")}
                          </span>
                        </div>
                        <div>
                          <div
                            className="material-icons"
                            style={{
                              background:
                                "linear-gradient(93deg, #007934 5.26%, #c9dd03 219.08%)",
                              backgroundClip: "text",
                              WebkitTextFillColor: "transparent"
                            }}
                          >
                            check_circle
                          </div>
                          <span>
                            {t("fathom.dialogContent.fathom'sHigh-resolution")}
                          </span>
                        </div>
                      </div>
                    </div>
                  </AccordionSummary>
                  <AccordionDetails
                    sx={{
                      padding: "0"
                    }}
                  >
                    <div className={styles.featureDetails}>
                      <div>
                        <ul>
                          <li>
                            {t(
                              "layers.item.Swiss Re and Official Fluvial Flood Zones"
                            )}
                          </li>
                          <li>{t("layers.item.Swiss Re Storm Surge Zones")}</li>
                          <li>
                            {t("layers.item.Earthquake Bedrock Conditions")}
                          </li>
                          <li>{t("layers.item.Tsunami")}</li>
                          <li>{t("layers.item.Windstorm")}</li>
                          <li>{t("layers.item.Hailstorm")}</li>
                          <li>{t("layers.item.Tornado")}</li>
                          <li>{t("layers.item.Lightning")}</li>
                          <li>{t("layers.item.Volcano Ash Thickness")}</li>
                          <li>{t("layers.item.France Subsidence")}</li>
                        </ul>
                      </div>
                      <div>
                        <ul>
                          <li>
                            {t(
                              "layers.item.Swiss Re Global Pluvial Flood Zones"
                            )}
                          </li>
                          <li>
                            {t(
                              "layers.item.Earthquake - Local Soil Conditions"
                            )}
                          </li>
                          <li>{t("layers.item.Landslide")}</li>
                          <li>{t("layers.item.Wildfire")}</li>
                          <li>{t("layers.item.Australia Distance to Bush")}</li>
                          <li>{t("report.Climate Risk Score")}</li>
                        </ul>
                      </div>
                      <div>
                        <span>
                          {t("fathom.dialogContent.thisHazardLayerProvides")}
                        </span>
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>
                <Accordion
                  sx={{
                    boxShadow: "0 1px 6px #0000001f, 0 1px 4px #0000001f",
                    width: "100%",
                    marginBottom: "16px"
                  }}
                  expanded={false}
                >
                  <AccordionSummary
                    expandIcon={<div className="material-icons"></div>}
                    sx={{
                      padding: 0,
                      margin: 0,
                      flexDirection: "row-reverse",
                      "&:hover": {
                        background: "#e0e0e0"
                      },
                      "& .MuiAccordionSummary-expandIconWrapper": {
                        margin: "0 8px 0 16px"
                      },
                      "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
                        transform: "rotate(90deg)"
                      },
                      "& .MuiTypography-root": {
                        fontFamily: "Roboto-Regular"
                      },
                      "& .MuiAccordionSummary-content.Mui-expanded": {
                        margin: " 0"
                      }
                    }}
                  >
                    <div className={styles.featureHeader}>
                      <span>{t("fathom.dialogContent.eventFootprints")}</span>
                      <div className={styles.tierContainer}>
                        <div>
                          <div className="material-icons">
                            horizontal_rule_outline
                          </div>
                          <span></span>
                        </div>
                        <div>
                          <div
                            className="material-icons"
                            style={{
                              background:
                                "linear-gradient(93deg, #007934 5.26%, #c9dd03 219.08%)",
                              backgroundClip: "text",
                              WebkitTextFillColor: "transparent"
                            }}
                          >
                            check_circle
                          </div>
                          <span>
                            {t(
                              "fathom.dialogContent.historicalEventFootprints"
                            )}
                          </span>
                        </div>
                        <div>
                          <div className="material-icons">
                            horizontal_rule_outline
                          </div>
                          <span></span>
                        </div>
                      </div>
                    </div>
                  </AccordionSummary>
                </Accordion>
                <Accordion
                  sx={{
                    boxShadow: "0 1px 6px #0000001f, 0 1px 4px #0000001f",
                    width: "100%"
                  }}
                  expanded={false}
                >
                  <AccordionSummary
                    expandIcon={<div className="material-icons"></div>}
                    sx={{
                      padding: 0,
                      margin: 0,
                      flexDirection: "row-reverse",
                      "&:hover": {
                        background: "#e0e0e0"
                      },
                      "& .MuiAccordionSummary-expandIconWrapper": {
                        margin: "0 8px 0 16px"
                      },
                      "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
                        transform: "rotate(90deg)"
                      },
                      "& .MuiTypography-root": {
                        fontFamily: "Roboto-Regular"
                      },
                      "& .MuiAccordionSummary-content.Mui-expanded": {
                        margin: " 0"
                      }
                    }}
                  >
                    <div className={styles.featureHeader}>
                      <span>
                        {t("fathom.dialogContent.dataImport&Encoding")}
                      </span>
                      <div className={styles.tierContainer}>
                        <div>
                          <div className="material-icons">
                            horizontal_rule_outline
                          </div>
                          <span></span>
                        </div>
                        <div>
                          <div
                            className="material-icons"
                            style={{
                              background:
                                "linear-gradient(93deg, #007934 5.26%, #c9dd03 219.08%)",
                              backgroundClip: "text",
                              WebkitTextFillColor: "transparent"
                            }}
                          >
                            check_circle
                          </div>
                          <span>
                            {t("fathom.dialogContent.importAndEncoded")}
                          </span>
                        </div>
                        <div>
                          <div
                            className="material-icons"
                            style={{
                              background:
                                "linear-gradient(93deg, #007934 5.26%, #c9dd03 219.08%)",
                              backgroundClip: "text",
                              WebkitTextFillColor: "transparent"
                            }}
                          >
                            check_circle
                          </div>
                          <span>
                            {t("fathom.dialogContent.importAndEncoded")}
                          </span>
                        </div>
                      </div>
                    </div>
                  </AccordionSummary>
                </Accordion>

                <div className={styles.floatingImageWrapper}>
                  <img
                    src={require("assets/image/laptop-premium-display.png")}
                    alt="Premium Feature Image"
                    className={styles.floatingImage}
                  />
                </div>
                <div className={styles.unlockContainer}>
                  <div className={styles.unlockContainerTitle}>
                    {" "}
                    {t("fathom.dialogContent.footTitle")}{" "}
                  </div>
                  <div className={styles.unlockContainerDesc}>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: t("fathom.dialogContent.foot")
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.dialogFoot}>
            <Button
              color="success"
              variant="contained"
              onClick={() => {
                dispatch({
                  type: AppAction.setFathomIconDialog,
                  payload: false
                });
              }}
            >
              {t(`buttons.close`)}
            </Button>
            {/* <Button variant="contained" color="success" href="mailto:catnet@swissre.com">{t(`buttons.contact`)}</Button> */}
          </div>
        </div>
      </Dialog>
    </div>
  );
}

export default Home;
